import React,{useEffect,useState} from 'react'
import {salesByProd,salesByProdBySeller} from 'network/ApiAxiosTickets'
import { Card, CardHeader, CardBody, Row, Col, CardImg,CardImgOverlay, Button,Modal, Input, ModalBody} from "reactstrap";
import { sendReminder } from 'network/ApiAxiosTickets';

function EventReportSalesCard(props) {
    const [event, setEvent] = useState(null);
    const [sellerTotal, setSellerTotal] = useState(0);
    const [msg, setMsg] = useState('');
    const [modal, setModal] = useState(false);
    const [dateString, setDateString] = useState('');

    const toggle = () => setModal(!modal);
    useEffect(() => {
        getEvent()
    }, []);
    
    const getEvent = async()=>{
        const res = await salesByProd(props.prodID)
        const ress = await salesByProdBySeller(props.prodID)
        res.data.Date && setDateString(res.data.Date.split(' ')[0] + ' at ' + res.data.Date.split(' ')[1])
        setEvent(res.data)
        setSellerTotal(ress.data)
        
    }

    const handleSendReminder = async ()=>{
        toggle()
        const resp = await sendReminder(props.prodID,dateString)
        if(resp.data.success){
            setMsg('Sent!')
        }else{
            setMsg('Error!')
        }
    }

  return event &&  (
    <Col className="mb-2" xl="6">
    <Card className="shadow">
        <CardHeader className="border-0 text-center">
            <Row className="text-center">
                <Col>
                    <h3 className="mt-6">{event.Name} </h3>
                </Col>
                <Col>
                <CardImg
                style={{borderRadius: "150px"}}
                alt="Card image cap"
                src={event.Image}
                top
                width="3%"
                />
                </Col>
            </Row>
        </CardHeader>
        {event && event.Name.includes('VIP') ?
        <CardBody className=" text-center">
            <strong>Total Tickets Sold: {event.Sales}</strong>
            <br></br>
            <strong>Total Tickets Left: {event.Stock}</strong>
            <hr></hr>
            <strong>Sold By Sellers: {sellerTotal}</strong>
            <br></br>
            <strong>Sold Online: {event.Sales - sellerTotal}</strong>
        </CardBody>
        :
        <CardBody className=" text-center">
            <strong>Total Tickets Sold: {event.Sales +sellerTotal}</strong>
            <br></br>
            <strong>Total Tickets Left: {event.Stock}</strong>
            <hr></hr>
            <strong>Sold By Sellers: {sellerTotal}</strong>
            <br></br>
            <strong>Sold Online: {event.Sales}</strong>
        </CardBody>
        }
        <Button onClick={()=>toggle()}>Send Reminder {msg && '  ' + msg}</Button>
        <Modal isOpen={modal} toggle={toggle} >
            <ModalBody>
                🎉 Hey CLIENT NAME! Just a friendly reminder about the awesome party you booked! 
                🥳 Don't forget it starts on the <input className=' d-inline' value={dateString} onChange={(e)=>setDateString(e.target.value)}/>. 
                Feel free to let me know if you have any questions or need directions. 
                See you there! 🕺💃 
                #PartyTime #Excited
                <p/>
                <Button className='btn-info' onClick={()=>handleSendReminder()}>Send Reminder</Button>
            </ModalBody>
        </Modal>
    </Card>
    </Col>
  )
}

export default EventReportSalesCard